import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { InterceptorSkipHeader } from '../auth/auth.interceptor';
import { timeout } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private httpClient: HttpClient) {}

  getUploadUrl(params: any): Observable<any> {
    const body = JSON.stringify(params);
    return this.httpClient
      .post(`${environment.apiEndpoint}/getUploadUrl`, body)
      .pipe(catchError(this._handleError));
  }

  parseDocEvent(body): Observable<any> {
    return this.httpClient
      .post(`${environment.apiEndpoint}/parseDocEvent`, body)
      .pipe(catchError(this._handleError));
  }

  getJobs(body): Observable<any> {
    return this.httpClient
      .post(`${environment.apiEndpoint}/getJobs`, body)
      .pipe(catchError(this._handleError));
  }

  listProjects(body): Observable<any> {
    return this.httpClient
      .post(`${environment.apiEndpoint}/listProjects`, body)
      .pipe(catchError(this._handleError));
  }

  getJob(body): Observable<any> {
    return this.httpClient
      .post(`${environment.apiEndpoint}/getJob`, body)
      .pipe(catchError(this._handleError));
  }

  downloadJSONFromS3<T>(jsonUrl: string) {
    const headers = new HttpHeaders()
      // .set('Content-Type', file.type)
      .set(InterceptorSkipHeader.Authorization, '');

    return this.httpClient.get<T>(jsonUrl, { headers });
  }

  updateJobVerificationStatus(data: {
    jobId: any;
    newStatus: string;
    currentValue: string;
  }): Observable<any> {
    return this.httpClient.put(
      `${environment.apiEndpoint}/job/updateVerificationStatus`,
      data,
    );
  }

  updateComments(data: {
    jobId: any;
    comments: string;
  }): Observable<any> {
    return this.httpClient.put(
      `${environment.apiEndpoint}/job/updateComments`,
      data,
    );
  }

  updateExtractedRes(data: {
    jobId: any;
    headers: object;
    extractedResKey
    multipleStatementsCombined: boolean
    statementIndex: number
    currentPageTransactionDetails: object
  }): Observable<any> {
    return this.httpClient.put(
      `${environment.apiEndpoint}/job/updateExtractedRes`,
      data,
    );
  }

  reprocess(body) {
    return this.httpClient
      .post(`${environment.apiEndpoint}/reprocess`, body).pipe(
        timeout(29000), // Timeout in milliseconds (30 seconds)
        catchError(error => {
          if (error.name === 'TimeoutError') {
            console.error('Request timed out');
            return of({ success: false, message: 'TimeoutError' }); // Return { success: false } on timeout
          } else {
            catchError(this._handleError)
          }
        })
      )
  }

  deleteJob(data: {
    jobId: any;
  }): Observable<any> {
    return this.httpClient.put(
      `${environment.apiEndpoint}/job/delete`,
      data,
    );
  }


  private _handleError(err: any) {
    // err = err.json();
    const errorMsg = err.message || 'Error: Unable to complete request.';
    console.log('Error in ApiService', errorMsg);
    return throwError(errorMsg);
  }
}
